module.exports = __webpack_public_path__ + "static/milyli-4515639e41ebbc86c2879f79306e9dd2.png";